module.exports = __webpack_public_path__ + "static/img/dash-4.c660558f.png";